import Toolbar from './Toolbar';

export default Toolbar;


// WEBPACK FOOTER //
// ./src/components/Toolbar/index.js